document.addEventListener("DOMContentLoaded", () => {

  const items = document.querySelectorAll(".ingredient-item");

  if (!items.length) return;

  items.forEach((item) => {

    const button = item.querySelector(".ingredient-header");

    const content = item.querySelector(".ingredient-content");

    const icon = item.querySelector(".ingredient-icon");

    // Set initial state
    if (item.classList.contains("active")) {
      content.style.display = "block";
      content.style.maxHeight = content.scrollHeight + "px";
      button.setAttribute("aria-expanded", "true");
      icon.textContent = "−";
    } else {
      content.style.display = "none";
      content.style.maxHeight = null;
      button.setAttribute("aria-expanded", "false");
      icon.textContent = "+";
    }

    button.addEventListener("click", () => {

      const isActive = item.classList.contains("active");

      // Close all items
      items.forEach((otherItem) => {

        const otherButton = otherItem.querySelector(".ingredient-header");
        const otherContent = otherItem.querySelector(".ingredient-content");
        const otherIcon = otherItem.querySelector(".ingredient-icon");

        otherItem.classList.remove("active");
        otherButton.setAttribute("aria-expanded", "false");
        otherIcon.textContent = "+";

        otherContent.style.maxHeight = null;

        setTimeout(() => {
          if (!otherItem.classList.contains("active")) {
            otherContent.style.display = "none";
          }
        }, 250);

      });

      // Open clicked item
      if (!isActive) {

        item.classList.add("active");

        button.setAttribute("aria-expanded", "true");

        icon.textContent = "−";

        content.style.display = "block";

        requestAnimationFrame(() => {
          content.style.maxHeight = content.scrollHeight + "px";
        });

      }

    });

  });

});